import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=11834746&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11834746"]])

export default __exports__